import React from "react";

const AddCoupon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    width="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M0 5.5L0 9.5H0.5C1.878 9.5 3 10.622 3 12C3 13.378 1.878 14.5 0.5 14.5H0L0 18.5C0 19.878 1.122 21 2.5 21H24V14.5H23.5C22.122 14.5 21 13.378 21 12C21 10.622 22.122 9.5 23.5 9.5H24V3H2.5C1.122 3 0 4.122 0 5.5ZM23 4V8.536C21.306 8.779 20 10.24 20 12C20 13.76 21.306 15.221 23 15.464V20H2.5C1.673 20 1 19.327 1 18.5L1 15.464C2.694 15.221 4 13.76 4 12C4 10.24 2.694 8.779 1 8.536L1 5.5C1 4.673 1.673 4 2.5 4H23ZM16 19V17H17V19H16ZM16 15V13H17V15H16ZM16 11V9H17V11H16ZM16 7V5H17V7H16Z"
    ></path>
  </svg>
);

export default AddCoupon;